import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-border bg-navy text-white/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-8">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <Logo light />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/50">
              More jobs. Better opportunities. Real results. The UK's network for live vacancies.
            </p>
          </div>
          {[
            { title: "For Job Seekers", links: [["Browse Jobs", "/jobs"], ["Saved Jobs", "/saved"], ["Career Advice", "/career-advice"], ["About Us", "/about"]] },
            { title: "For Employers", links: [["Advertise a Job", "/employers"], ["Make an Enquiry", "/employers"], ["About Us", "/about"]] },
            { title: "Company", links: [["About", "/about"], ["Career Advice", "/career-advice"], ["Employers", "/employers"]] },
          ].map((col, i) => (
            <div key={i}>
              <h4 className="mb-4 text-sm font-semibold text-white">{col.title}</h4>
              <ul className="space-y-2.5 text-sm">
                {col.links.map(([label, to], j) => (
                  <li key={j}>
                    <Link to={to} className="transition-colors hover:text-accent">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-col gap-1.5 border-t border-white/10 pt-6 text-xs text-white/40">
          <p data-testid="footer-company-info">
            VACANCY NETWORK LIMITED · Company number 12977280 · Registered in England &amp; Wales
          </p>
          <p>© {new Date().getFullYear()} Vacancy Network. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
